/**
 * Dev-only "use it as <account>" personas for the inline editor + review cockpit.
 *
 * These emails are seeded into the LOCAL review DB (`review_local`, see
 * `lib/review/schema.sql` + the dev-setup skill) so that picking a persona in the
 * dev switcher loads that reviewer's real scope (locales + tiers) and attributes
 * CMS drafts / sign-offs to them. They never exist in any deployed environment —
 * the switcher and the server-side `dev:` token path are both gated behind
 * `DEV_EDITOR_IMPERSONATION` + a non-production runtime.
 *
 * Keep this list in sync with `scripts/seed-review-personas.sql`.
 */
export interface DevPersona {
  email: string
  label: string
  /** What this persona is useful for testing. */
  note: string
}

export const DEV_PERSONAS: DevPersona[] = [
  {
    email: "nick@aheadhealth.com",
    label: "Nick (full scope)",
    note: "de · de-DE · fr — legal + glossary + high-traffic. Sees every queue.",
  },
  {
    email: "fr-reviewer@aheadhealth.com",
    label: "FR reviewer",
    note: "fr only, high-traffic — French worklist, no legal tier.",
  },
  {
    email: "legal-reviewer@aheadhealth.com",
    label: "Legal reviewer (de-DE)",
    note: "de-DE only, legal tier — regulatory strings only.",
  },
  {
    email: "outsider@aheadhealth.com",
    label: "No scope (not a reviewer)",
    note: "Verified email but no reviewer row — empty-scope UX.",
  },
]
